import { ContainerTeam, Groups } from "./styles";
import maskgroup1 from '../../assets/Img/maskgroup1.png';
import maskgroup2 from '../../assets/Img/maskgroup2.png';
import maskgroup3 from '../../assets/Img/maskgroup3.png';
import maskgroup4 from '../../assets/Img/maskgroup4.png';
import maskgroup5 from '../../assets/Img/maskgroup5.png';
import maskgroup6 from '../../assets/Img/maskgroup6.png';


export function Team() {
    return (
        <ContainerTeam>
            <h2>Our team </h2>
            <Groups>
                <div className="inner-group">
                    <div>
                        <img src={maskgroup4} alt="co-founder avatar" />
                        <p>Mr T</p>
                        <p>Fractalia Co-Founder</p>
                    </div>
                    <div>
                        <img src={maskgroup5} alt="co-founder avatar" />
                        <p>7thGin</p>
                        <p>Fractalia Co-Founder</p>
                    </div>
                    <div>
                        <img src={maskgroup6} alt="concept artist avatar" />
                        <p>Darrin</p>
                        <p>Fractalia Concept Artist</p>
                    </div>
                </div>
                <div className="inner-group">
                    <div>
                        <img src={maskgroup2} alt="architect avatar" />
                        <p>Travs#66e4</p>
                        <p>Fractalia Architect</p>
                    </div>
                    <div>
                        <img src={maskgroup3} alt="storyteller avatar" />
                        <p>GalaxiaVolatil_19</p>
                        <p>Fractalia Storyteller</p>
                    </div>
                    <div>
                        <img src={maskgroup1} alt="designer avatar" />
                        <p>David#a4ad</p>
                        <p>Fractalia Designer</p>
                    </div>
                </div>
            </Groups>
        </ContainerTeam>
    )
}